import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep, cloneDeepWith} from "lodash";
import * as $ from "jquery";
import {Batiment} from "../Models/Batiment";
import {parse} from "@angular/compiler/src/render3/view/style_parser";

@Component({
	selector: 'app-modal-nb-niveaux',
	templateUrl: './modal-nb-niveaux.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-nb-niveaux.component.less']
})
export class ModalNbNiveauxComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	modalData: any;
	modalInfo: any;
	prmSurfacesNiveau: any = {
		id: 1010,
		libelle: "Surfaces par niveau",
		img: "",
		value: "",
		type: -1,
		options: []
	};
	isSubmit: boolean = false;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
			console.log("modalInfo  => ", modalInfo);
			this.modalInfo = modalInfo;
		});

		this.getInfosInit();
	}

	getInfosInit() {
		// ==> On GET le JSON des Textes globaux
		this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

			// ==> Si l'objet n'est pas encore défini dans les dataTools, alors on appele la fonction dans sharedTools pour remplir l'objet dans les dataTools
			if (!object) this.app.sharedToolsService.getGlobalTexts();

			this.globalTxt = object;

			// ==> On CALL les textes des modals
			this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
				//console.log("resp ==> ", resp);

				this.modalsTxt = cloneDeep(resp.data);

				let modalOpen = JSON.parse(localStorage.getItem('modalOpen')!);
				this.modalData = (modalOpen) ? modalOpen.data : "";
				console.log("this.modalData ==> ", this.modalData);

				// ==> On récupère les données du bâtiment dans le localstorage
				this.batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
				if (this.batiment) console.log("this.batiment:", this.batiment);

				const surfaces = (this.batiment.surfacesNiveau) ? this.batiment.surfacesNiveau.split(';') : [];

				this.prmSurfacesNiveau.options = [];

				for (let i = 0; i < parseInt(this.modalData); i++) {
					this.prmSurfacesNiveau.options.push({
						id: i + 1,
						label: 'Niveau ' + (i + 1).toString(),
						value: (surfaces[i]) ? parseInt(surfaces[i]) : 0
					});
				}
			})
		});
	}

	validate() {
		console.log("this.prmSurfacesNiveau ==>", this.prmSurfacesNiveau);

		this.prmSurfacesNiveau.value = "";

		let isFormOk = true;
		for (let i = 0; i < parseInt(this.modalData); i++) {
			isFormOk = isFormOk && this.prmSurfacesNiveau.options[i].value;

			if (this.prmSurfacesNiveau.options[i].value)
				this.prmSurfacesNiveau.value += this.prmSurfacesNiveau.options[i].value.toString() + ";"
		}

		this.isSubmit = true;

		if (!isFormOk) {
			this.prmSurfacesNiveau.value = "";
			return;
		}

		console.log("this.prmSurfacesNiveau.value ==>", this.prmSurfacesNiveau.value);

		setTimeout(() => {
			this.batiment.surfacesNiveau = this.prmSurfacesNiveau.value;
			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));

			this.modalInfo.noFn();
		}, 100);
	}
}
